export const audioSelector = state => state.audio

export const progressSelector = state => state.progress

export const languageSelector = state => state.language

export const subtitlesLanguageSelector = state => state.subtitlesLanguage

export const hasCompletedQuizSelector = state => state.hasCompletedQuiz
